import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const abs = (u) => (u && u.startsWith("/") ? `${BASE}${u}` : u);
export const err = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
export const panel = "rounded-2xl border border-white/[0.06] bg-[#111318]";

export const useCatalog = () => { const [c, setC] = useState(null); useEffect(() => { api.get("/studio/catalog").then((r) => setC(r.data)).catch(() => {}); }, []); return c; };

export const useCredits = (user) => {
  const [w, setW] = useState(null);
  const load = () => user && api.get("/studio/credits").then((r) => setW(r.data)).catch(() => {});
  useEffect(() => { load(); }, [user]); // eslint-disable-line
  return [w, load];
};

export const uploadAsset = async (file) => { const fd = new FormData(); fd.append("file", file); const r = await api.post("/studio/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); return r.data.url; };

export const usePollJobs = (jobs, setJobs) => {
  useEffect(() => {
    const pending = (jobs || []).filter((j) => ["queued", "running"].includes(j.status));
    if (!pending.length) return;
    const t = setInterval(async () => { for (const j of pending) { try { const r = await api.get(`/studio/jobs/${j.job_id}`); if (r.data.status !== j.status) { setJobs((cur) => cur.map((x) => (x.job_id === j.job_id ? r.data : x))); if (r.data.status === "done") toast.success("Creation ready"); if (r.data.status === "failed") toast.error(`Generation failed · credits refunded`); } } catch {} } }, 4000);
    return () => clearInterval(t);
  }, [jobs]); // eslint-disable-line
};

export const Media = ({ job, className = "" }) => {
  if (!job.output_url) return <div className={`grid place-items-center bg-[#0b0d12] text-slate-500 text-xs ${className}`}>{job.status === "failed" ? "Failed" : "Rendering…"}</div>;
  return job.kind === "image" ? <img src={abs(job.output_url)} alt="" className={`object-cover ${className}`} loading="lazy" /> : <video src={abs(job.output_url)} controls playsInline className={`object-cover bg-black ${className}`} />;
};
